import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getDdrmsRepositoryDocuments, loadDdrmsRepositoryDocs } from "../../store/ddrmsDocument";
import DataMapping from "./DataMapping";
import AddDataTypeMapping from "./AddDataTypeMapping";
import { getSubsCurrentWfTask, loadSubcontractorWfTask, subsCurrentWfTaskReceived } from "../../store/subcontractor";
import { getRecCurrentWfTask, loadRecruiterWfTask, recCurrentWfTaskReceived } from "../../store/recruiter";
import { candidateCurrentWfTaskReceived, getCandidateCurrentWfTask, loadCandidateWfTask } from "../../store/candidate";
import useDocDownload from "../../hooks/useDocDownload";
import { getDataTypeMappings, loadAllDataTypeMappings, deleteDataTypeMapping, getMappingAddedStatus } from "../../store/dataTypes";
import { getAlert, getConfirmAlert } from "../../../services/appAlerts";

const GenerateContract = (props) => {
    const { showHide, uploadType, handleModalShowHide, workflowTask, app, applicantObj, viewType, prevItem, ddrmsDocId, defaultMappingId, embedded = false, bodyOnly = false, autoSave = false, deferSave = false, initialGeneratedData = null, onStageGenerated = null } = props;

    const [repositoryDocs, setRepositoryDocs] = useState([]);
    const [selectedDoc, setSelectedDoc] = useState(null);
    const [selectedDocId, setSelectedDocId] = useState(null);
    const [selectedKey, setSelectedKey] = useState("selectDocument");
    const [wfTaskReqCount, setWfTaskReqCount] = useState(0);
    const [repositoryLoading, setRepositoryLoading] = useState(false);
    const [wfTask, setWfTask] = useState(null);
    const [editingProfile, setEditingProfile] = useState(null);
    const [dataTypeMappings, setDataTypeMappings] = useState([]);
    const [isDeleting, setIsDeleting] = useState(false);
    const [profileSearchText, setProfileSearchText] = useState("");

    const [handleDownloadFile] = useDocDownload();

    const ddrmsRepositoryDocumentsSelector = useSelector(getDdrmsRepositoryDocuments);

    const subsCurrentWfTaskSelector = useSelector(getSubsCurrentWfTask);
    const recCurrentWfTaskSelector = useSelector(getRecCurrentWfTask);
    const candidateCurrentWfTaskSelector = useSelector(getCandidateCurrentWfTask);
    const dataTypeMappingsSelector = useSelector(getDataTypeMappings);
    const mappingAddedStatusSelector = useSelector(getMappingAddedStatus);

    const dispatch = useDispatch();
    const repositoryLoadStartedRef = useRef(false);

    useEffect(() => {
        setSelectedKey("selectDocument");
    }, [viewType]);

    useEffect(() => {
        dispatch(loadAllDataTypeMappings());
    }, []);

    useEffect(() => {
        let perfType = "";
        if (uploadType === "Subcontractor") {
            perfType = "Sub-Contractors";
        } else if (uploadType === "Candidate") {
            perfType = "candidate";
        } else if (uploadType === "Recruiter") {
            perfType = "Recruiter";
        }
        if (dataTypeMappingsSelector) {
            setDataTypeMappings(dataTypeMappingsSelector.filter(x => x.type === perfType));
        }
    }, [dataTypeMappingsSelector, uploadType]);

    useEffect(() => {
        if (mappingAddedStatusSelector) {
            if (isDeleting) {
                getAlert("", "Deleted Successfully", "success");
                setIsDeleting(false);
                dispatch(loadAllDataTypeMappings());
            }
        }
    }, [mappingAddedStatusSelector, isDeleting]);

    const handleDeleteProfile = async (item) => {
        const result = await getConfirmAlert("Warning", `Are you sure you want to delete the mapping profile "${item.name}"?`, "warning");
        if (result.isConfirmed) {
            setIsDeleting(true);
            dispatch(deleteDataTypeMapping(item.id));
        }
    };

    useEffect(() => {
        console.log(workflowTask);
        if (workflowTask?.ciid > 0) {
            handleDocRefresh(workflowTask)
            setWfTask(workflowTask);
        } else if (applicantObj?.id) {

            if (prevItem?.applications?.length > 0)
                handleDocRefresh({ ciid: prevItem.applications[0].ciid })

            if (uploadType === "Subcontractor") {
                let partnerUsrId = applicantObj?.id;
                if (viewType === "candidateList")
                    partnerUsrId = applicantObj?.subcontractor?.parentid;
                if (partnerUsrId > 0) {
                    dispatch(loadSubcontractorWfTask(partnerUsrId));
                    setWfTaskReqCount(wfTaskReqCount + 1)
                }
            }

            if (uploadType === "Recruiter") {
                let partnerUsrId = applicantObj?.id;
                if (viewType === "candidateList")
                    partnerUsrId = applicantObj?.recruiter?.parentid;
                if (partnerUsrId > 0) {
                    dispatch(loadRecruiterWfTask(partnerUsrId));
                    setWfTaskReqCount(wfTaskReqCount + 1)
                }
            }

            if (uploadType === "Candidate") {
                dispatch(loadCandidateWfTask(applicantObj?.id));
                setWfTaskReqCount(wfTaskReqCount + 1);
            }
        }
    }, []);

    useEffect(() => {
        console.log(subsCurrentWfTaskSelector)
        if (subsCurrentWfTaskSelector && subsCurrentWfTaskSelector !== 0) {
            setWfTask(subsCurrentWfTaskSelector)
            setWfTaskReqCount(0);
        }
        else if (subsCurrentWfTaskSelector === 0 && !workflowTask && wfTaskReqCount <= 5) {
            let partnerUsrId = applicantObj?.id;
            if (viewType === "candidateList")
                partnerUsrId = applicantObj?.subcontractor?.parentid;
            if (partnerUsrId > 0) {
                setWfTaskReqCount(wfTaskReqCount + 1)
                dispatch(subsCurrentWfTaskReceived(null));
                setTimeout(() => {
                    dispatch(loadSubcontractorWfTask(partnerUsrId));
                }, 1000);
            }
        }
    }, [subsCurrentWfTaskSelector]);

    useEffect(() => {
        console.log(recCurrentWfTaskSelector)
        if (recCurrentWfTaskSelector && recCurrentWfTaskSelector !== 0) {
            setWfTask(recCurrentWfTaskSelector)
            setWfTaskReqCount(0);
        } else if (recCurrentWfTaskSelector === 0 && !workflowTask && wfTaskReqCount <= 5) {
            let partnerUsrId = applicantObj?.id;
            if (viewType === "candidateList")
                partnerUsrId = applicantObj?.recruiter?.parentid;
            if (partnerUsrId > 0) {
                setWfTaskReqCount(wfTaskReqCount + 1)
                dispatch(recCurrentWfTaskReceived(null));
                setTimeout(() => {
                    dispatch(loadRecruiterWfTask(partnerUsrId));
                }, 1000);
            }
        }
    }, [recCurrentWfTaskSelector]);

    useEffect(() => {
        console.log(candidateCurrentWfTaskSelector)
        if (candidateCurrentWfTaskSelector && candidateCurrentWfTaskSelector !== 0) {
            setWfTask(candidateCurrentWfTaskSelector)
            setWfTaskReqCount(0)
        } else if (candidateCurrentWfTaskSelector === 0 && !workflowTask && wfTaskReqCount <= 5) {
            setWfTaskReqCount(wfTaskReqCount + 1)
            dispatch(candidateCurrentWfTaskReceived(null));
            dispatch(loadCandidateWfTask(applicantObj?.id));
        }
    }, [candidateCurrentWfTaskSelector]);

    useEffect(() => {
        if (wfTask?.ciid > 0) {
            handleDocRefresh(wfTask);
        }
    }, [wfTask]);

    useEffect(() => {
        if (ddrmsRepositoryDocumentsSelector.length > 0) {
            const filterDocx = ddrmsRepositoryDocumentsSelector.filter(x => x.fileExtension === "docx");
            setRepositoryDocs(filterDocx);
        }
        else {
            setRepositoryDocs([]);
        }
        if (repositoryLoadStartedRef.current) {
            setRepositoryLoading(false);
            repositoryLoadStartedRef.current = false;
        }
    }, [ddrmsRepositoryDocumentsSelector]);

    useEffect(() => {
        if (ddrmsDocId && repositoryDocs.length > 0) {
            const found = repositoryDocs.find(doc => doc.id === parseInt(ddrmsDocId));
            if (found) {
                setSelectedDoc(found);
                setSelectedDocId(found.id);
                setSelectedKey("generateDocument");
            }
        }
    }, [ddrmsDocId, repositoryDocs]);

    const handleDocRefresh = (task = wfTask) => {
        if (task?.ciid > 0) {
            repositoryLoadStartedRef.current = true;
            setRepositoryLoading(true);
            dispatch(loadDdrmsRepositoryDocs(task.ciid));
        }
    }


    const handleResetSelection = () => {
        setSelectedDocId(0);
        setSelectedDoc(null);
    }

    const handleSelection = (item) => {
        setSelectedDoc(item);
        setSelectedDocId(item.id);
    };

    const handleGenerateFromSelection = (item) => {
        setSelectedDoc(item);
        setSelectedDocId(item.id);
        setSelectedKey("generateDocument");
    };

    const handleCloseMapping = (type) => {
        setSelectedDocId(0);
        setSelectedDoc(null);
        if (type === "stage") {
            handleModalShowHide(type);
            return;
        }
        setTimeout(() => {
            handleModalShowHide(type)
        }, 3000);
    }

    const handleSelectedKey = (key) => {
        setSelectedKey(key);
    }

    const personName = [
        applicantObj?.performername,
        applicantObj?.firstName,
        applicantObj?.name,
        applicantObj?.lastName
    ].filter(Boolean).join(" ");
    const displayName = personName || applicantObj?.email || applicantObj?.performeremail || "Selected profile";
    const canGenerateDocuments = true;
    const selectedDocReady = selectedDocId > 0;
    const showRepositoryLoading = repositoryLoading;
    const showRepositoryEmpty = !repositoryLoading && repositoryDocs.length === 0;
    const Container = embedded ? "div" : Modal;

    const candidateName = applicantObj?.performername || applicantObj?.performerName || applicantObj?.label || applicantObj?.name || "";
    const candidateId = applicantObj?.performerid || applicantObj?.fuid || applicantObj?.id || "";
    const currentCiid = wfTask?.ciid || workflowTask?.ciid || "";

    return <>
        <style>{`
            .modal-backdrop {
                z-index: 1080 !important;
            }
            .modal {
                z-index: 1090 !important;
            }
            .modal-backdrop.show {
                backdrop-filter: blur(8px) !important;
                -webkit-backdrop-filter: blur(8px) !important;
                background-color: rgba(15, 23, 42, 0.45) !important;
                opacity: 1 !important;
            }
            .modal.fade .gc-modal.modal-dialog {
                transform: scale(0.95) !important;
                transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
            }
            .modal.show .gc-modal.modal-dialog {
                transform: scale(1) !important;
            }
            .gc-modal {
                max-width: 90% !important;
                width: 1200px !important;
                font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
                color: #1e293b !important;
            }
            .gc-modal .modal-content {
                border-radius: 0 !important;
                box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
                overflow: hidden !important;
                background: #ffffff !important;
                border: 1px solid #cbd5e1 !important;
                max-height: calc(100vh - 60px) !important;
                display: flex !important;
                flex-direction: column !important;
            }
            .gc-shell,
            .gc-shell button,
            .gc-shell input,
            .gc-shell select,
            .gc-shell textarea {
                font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
            }
            .gc-shell {
                background: #ffffff;
                max-height: calc(100vh - 60px);
                display: flex;
                flex-direction: column;
                min-height: 0;
            }
            .gc-modal .modal-header {
                position: relative !important;
                display: block !important;
                padding: 22px 28px 18px !important;
                background: #ffffff !important;
                border-bottom: 1px solid #edf2f7 !important;
            }
            .gc-modal .rt-header-shell {
                display: flex !important;
                flex-direction: column !important;
                gap: 12px !important;
                width: 100% !important;
            }
            .gc-modal .rt-header-top {
                display: flex !important;
                justify-content: space-between !important;
                align-items: flex-start !important;
                gap: 16px !important;
                width: 100% !important;
            }
            .gc-modal .rt-header-main {
                display: flex !important;
                align-items: center !important;
                gap: 14px !important;
                min-width: 0 !important;
                flex: 1 1 auto !important;
            }
            .gc-modal .rt-header-icon {
                width: 48px !important;
                height: 48px !important;
                min-height: 48px !important;
                border-radius: 0 !important;
                display: inline-flex !important;
                align-items: center !important;
                justify-content: center !important;
                color: #171717 !important;
                background: #f5f5f5 !important;
                border: 1px solid #d4d4d4 !important;
                box-shadow: 0 2px 6px -2px rgba(15,23,42,0.08) !important;
                font-size: 18px !important;
                flex-shrink: 0 !important;
            }
            .gc-modal .rt-header-copy {
                display: flex !important;
                flex-direction: column !important;
                gap: 6px !important;
                min-width: 0 !important;
            }
            .gc-modal .rt-modal-title {
                display: inline-flex !important;
                align-items: center !important;
                margin: 0 !important;
                color: #1e293b !important;
                font-size: 18px !important;
                font-weight: 500 !important;
                line-height: 1.2 !important;
            }
            .gc-modal .rt-modal-title-text {
                display: inline-flex !important;
                align-items: center !important;
                gap: 10px !important;
                flex-wrap: wrap !important;
            }
            .gc-modal .rt-modal-title-badge {
                display: inline-flex !important;
                align-items: center !important;
                justify-content: center !important;
                padding: 3px 8px !important;
                border-radius: 0 !important;
                font-size: 11px !important;
                font-weight: 600 !important;
                text-transform: uppercase !important;
                letter-spacing: 0.04em !important;
                background: #171717 !important;
                color: #ffffff !important;
                border: 1px solid #171717 !important;
            }
            .gc-modal .rt-modal-meta-row {
                display: flex !important;
                align-items: center !important;
                flex-wrap: wrap !important;
                gap: 8px !important;
                font-size: 12px !important;
            }
            .gc-modal .rt-meta-chip {
                display: inline-flex !important;
                align-items: center !important;
                gap: 4px !important;
                background: #ffffff !important;
                padding: 3px 8px !important;
                height: 24px !important;
                min-height: 24px !important;
                box-sizing: border-box !important;
                border-radius: 0 !important;
                font-size: 11.5px !important;
                font-weight: 500 !important;
                color: #0f172a !important;
                border: 1px solid #cbd5e1 !important;
            }
            .gc-modal .rt-action-btn {
                display: inline-flex !important;
                align-items: center !important;
                justify-content: center !important;
                width: 38px !important;
                height: 38px !important;
                padding: 0 !important;
                font-size: 14px !important;
                color: #64748b !important;
                background: #ffffff !important;
                border: 1px solid #cbd5e1 !important;
                border-radius: 0 !important;
                cursor: pointer !important;
                transition: all 0.2s ease !important;
                box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
                outline: none !important;
            }
            .gc-modal .rt-action-btn:hover {
                color: #1e293b !important;
                border-color: #94a3b8 !important;
                background: #f8fafc !important;
                transform: translateY(-1px) !important;
            }
            .gc-modal .rt-action-btn:hover i {
                color: #ef4444 !important;
            }
            .gc-body {
                padding: 0 24px 24px;
                background: #ffffff;
                overflow: hidden;
                min-height: 0;
                display: flex;
                flex-direction: column;
            }
            .gc-tab-bar {
                display: flex;
                align-items: stretch;
                gap: 4px;
                border-bottom: 2px solid #e5e5e5;
                margin-bottom: 16px;
                padding: 14px 0 0;
                position: relative;
                flex: 0 0 auto;
            }
            .gc-tab-btn {
                position: relative;
                display: inline-flex;
                align-items: center;
                gap: 7px;
                border: none;
                background: transparent;
                padding: 9px 16px 11px;
                font-size: 14px;
                font-weight: 500;
                color: #1e293b;
                cursor: pointer;
                border-radius: 0 !important;
                transition: color 0.2s ease, background 0.2s ease;
                outline: none;
                white-space: nowrap;
            }
            .gc-tab-btn i {
                font-size: 14px;
                color: currentColor;
                transition: color 0.2s ease;
            }
            .gc-tab-btn:hover {
                color: #0f172a;
                background: #f5f5f5;
            }
            .gc-tab-btn:focus,
            .gc-tab-btn:focus-visible,
            .gc-tab-btn:active {
                outline: none !important;
                box-shadow: none !important;
                border-color: transparent !important;
            }
            .gc-tab-btn.active {
                color: #ffffff;
                font-weight: 500;
                background: #171717;
            }
            .gc-tab-btn.active i {
                color: #ffffff;
            }
            .gc-tab-badge {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                min-width: 20px;
                height: 20px;
                padding: 0 6px;
                border-radius: 0 !important;
                font-size: 12px;
                font-weight: 600;
                background: #f1f5f9;
                color: #1e293b;
                border: 1px solid #e2e8f0;
                transition: all 0.2s ease;
                line-height: 1;
            }
            .gc-tab-btn.active .gc-tab-badge {
                background: #ffffff !important;
                color: #171717 !important;
                border-color: #ffffff !important;
            }
            .gc-panel {
                border: 1px solid #cbd5e1;
                border-radius: 0 !important;
                overflow: hidden;
                background: #ffffff;
                box-shadow: none !important;
                min-height: 0;
                display: flex;
                flex-direction: column;
            }
            .gc-toolbar {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 16px;
                padding: 14px 18px;
                background: #ffffff;
                border-bottom: 1px solid #e2e8f0;
            }
            .gc-section-label {
                display: inline-flex;
                align-items: center;
                gap: 8px;
                margin: 0;
                color: #334155;
                font-size: 12px;
                font-weight: 700;
                text-transform: uppercase;
                letter-spacing: 0.04em;
            }
            .gc-section-label i { color: #2563eb; }
            .gc-note { margin: 4px 0 0; color: #64748b; font-size: 12.5px; font-weight: 400; }
            .gc-actions { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; justify-content: flex-end; }
            .gc-action-btn {
                min-height: 36px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                gap: 7px;
                font-size: 12.5px;
                font-weight: 500;
                border-radius: 0 !important;
                cursor: pointer;
                transition: all 0.15s ease;
                padding: 7px 14px;
                border: 1px solid #cbd5e1;
                background: #ffffff;
                color: #1e293b;
                white-space: nowrap;
                box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
            }
            .gc-action-btn:hover { background: #f8fafc; border-color: #94a3b8; transform: translateY(-1px); }
            .gc-action-btn.primary { background: #2563eb; border-color: #2563eb; color: #ffffff; box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2); }
            .gc-action-btn.primary:hover { background: #1d4ed8; border-color: #1d4ed8; color: #ffffff; }
            .gc-doc-list {
                display: flex;
                flex-direction: column;
                gap: 0;
                max-height: calc(100vh - 385px);
                min-height: 180px;
                overflow-y: auto;
                overflow-x: hidden;
                padding: 0;
                background: #ffffff;
                scrollbar-width: thin;
                scrollbar-color: #cbd5e1 transparent;
            }
            .gc-doc-list::-webkit-scrollbar {
                width: 6px;
                height: 6px;
            }
            .gc-doc-list::-webkit-scrollbar-track {
                background: transparent;
            }
            .gc-doc-list::-webkit-scrollbar-thumb {
                background: #cbd5e1;
                border-radius: 0;
            }
            .gc-doc-row {
                display: flex;
                align-items: center;
                gap: 12px;
                padding: 14px 18px;
                border: 0;
                border-bottom: 1px solid #e2e8f0;
                border-radius: 0 !important;
                background: #ffffff;
                cursor: pointer;
                transition: all 0.15s ease;
                box-shadow: none !important;
            }
            .gc-doc-row:hover {
                background: #f8fafc;
            }
            .gc-doc-row.selected {
                background: #f8fafc;
                border-bottom-color: #cbd5e1;
            }
            .gc-doc-checkbox {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                position: relative;
                width: 18px;
                height: 18px;
                flex-shrink: 0;
            }
            .gc-doc-checkbox input {
                opacity: 0;
                position: absolute;
                width: 0;
                height: 0;
            }
            .gc-checkbox-custom {
                width: 18px;
                height: 18px;
                border: 2px solid #cbd5e1;
                border-radius: 0 !important;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                transition: all 0.15s ease;
            }
            .gc-doc-row.selected .gc-checkbox-custom {
                background: #171717;
                border-color: #171717;
            }
            .gc-checkbox-custom::after {
                content: "";
                display: none;
                width: 5px;
                height: 9px;
                border: solid white;
                border-width: 0 2px 2px 0;
                transform: rotate(45deg);
                margin-bottom: 2px;
            }
            .gc-doc-row.selected .gc-checkbox-custom::after {
                display: block;
            }
            .gc-doc-icon {
                width: 34px;
                height: 34px;
                border-radius: 0 !important;
                background: #ffffff;
                border: 1px solid #cbd5e1;
                color: #2563eb;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                font-size: 15px;
                flex-shrink: 0;
            }
            .gc-doc-main {
                flex: 1;
                min-width: 0;
                display: flex;
                flex-direction: column;
                gap: 3px;
            }
            .gc-doc-title {
                font-size: 13.5px;
                font-weight: 600;
                color: #0f172a;
            }
            .gc-doc-meta {
                display: flex;
                align-items: center;
                gap: 10px;
                font-size: 11.5px;
                color: #64748b;
            }
            .gc-row-download,
            .gc-row-generate {
                min-height: 32px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                gap: 6px;
                padding: 6px 14px;
                border: 1px solid #cbd5e1;
                border-radius: 0 !important;
                background: #ffffff;
                color: #1e293b;
                font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                font-size: 13px;
                font-weight: 500;
                cursor: pointer;
                white-space: nowrap;
                transition: all 0.15s ease;
                outline: none !important;
                box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
            }
            .gc-row-download:hover,
            .gc-row-generate:hover {
                background: #f8fafc;
                border-color: #94a3b8;
                color: #0f172a;
                transform: translateY(-1px);
            }
            .gc-action-btn:disabled {
                opacity: 0.6;
                cursor: not-allowed;
                transform: none;
            }
            .gc-state {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 40px 20px;
                text-align: center;
                color: #64748b;
            }
            .gc-state h5 {
                margin: 0 0 4px;
                font-size: 14px;
                font-weight: 600;
                color: #0f172a;
            }
            .gc-state p {
                margin: 0;
                font-size: 12.5px;
            }
            .gc-empty-icon {
                font-size: 28px;
                color: #cbd5e1;
                margin-bottom: 8px;
            }
            .gc-no-selection {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                min-height: 260px;
                text-align: center;
                padding: 34px;
                color: #64748b;
                background: #f8fafc;
            }
            .gc-no-selection-icon {
                width: 44px;
                height: 44px;
                border-radius: 0 !important;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                background: #ffffff;
                color: #b45309;
                border: 1px solid #fed7aa;
                margin-bottom: 12px;
                font-size: 16px;
            }
            .gc-no-selection .gc-action-btn { margin-top: 16px; }
            .gc-selected-summary {
                display: grid;
                grid-template-columns: 34px minmax(0, 1fr) auto;
                align-items: center;
                gap: 12px;
                padding: 14px 18px;
                background: #ffffff;
                border-bottom: 1px solid #e2e8f0;
            }
            .gc-mapping-wrap {
                padding: 16px;
                flex: 1;
                overflow-y: auto;
                min-height: 0;
                scrollbar-width: thin;
                scrollbar-color: #cbd5e1 transparent;
            }
            .gc-mapping-wrap::-webkit-scrollbar {
                width: 6px;
                height: 6px;
            }
            .gc-mapping-wrap::-webkit-scrollbar-track {
                background: transparent;
            }
            .gc-mapping-wrap::-webkit-scrollbar-thumb {
                background: #cbd5e1;
                border-radius: 0;
            }
            .gc-modal .modal-footer {
                padding: 16px 24px !important;
                background: #f8fafc !important;
                border-top: 1px solid #edf2f7 !important;
                display: flex !important;
                align-items: center !important;
                justify-content: flex-end !important;
            }
            .wf-modal-footer-close-btn {
                display: inline-flex !important;
                align-items: center !important;
                gap: 7px !important;
                padding: 7px 16px !important;
                font-size: 13.5px !important;
                font-weight: 500 !important;
                color: #1e293b !important;
                background: #ffffff !important;
                border: 1px solid #cbd5e1 !important;
                border-radius: 0 !important;
                box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
                outline: none !important;
                cursor: pointer !important;
                transition: all 0.2s ease !important;
            }
            .wf-modal-footer-close-btn:hover {
                background: #f8fafc !important;
                color: #1e293b !important;
                border-color: #94a3b8 !important;
                transform: translateY(-1px) !important;
            }
            .wf-modal-footer-close-btn:hover i {
                color: #ef4444 !important;
            }
            .gc-table-container {
                overflow-x: auto;
                background: #ffffff;
                border-top: 1px solid #e2e8f0;
            }
            .gc-table {
                width: 100%;
                border-collapse: collapse;
                text-align: left;
                font-size: 13px;
            }
            .gc-table thead {
                background: #f8fafc !important;
                position: sticky !important;
                top: 0 !important;
                z-index: 2 !important;
            }
            .gc-table th {
                font-size: 12px !important;
                font-weight: 600 !important;
                color: #64748b !important;
                text-transform: uppercase !important;
                letter-spacing: 0.6px !important;
                padding: 13px 16px !important;
                border-bottom: 2px solid #e2e8f0 !important;
                border-top: none !important;
                border-left: none !important;
                border-right: none !important;
                white-space: nowrap !important;
            }
            .gc-table td {
                padding: 12px 16px;
                vertical-align: middle;
                border-bottom: 1px solid #f1f5f9;
                color: #1e293b;
            }
            .gc-table-row {
                transition: background 0.15s ease;
            }
            .gc-table-row:hover {
                background: #f8fafc;
            }
            .gc-id-badge {
                font-family: Menlo, Monaco, Consolas, monospace;
                font-size: 11.5px;
                font-weight: 600;
                color: #64748b;
                background: #f1f5f9;
                padding: 3px 7px;
                border: 1px solid #cbd5e1;
                border-radius: 0 !important;
            }
            .gc-profile-name {
                font-size: 13.5px;
                font-weight: 600;
                color: #0f172a;
            }
            .gc-fields-badge {
                display: inline-flex;
                align-items: center;
                gap: 5px;
                background: #ffffff;
                color: #1e293b;
                font-size: 12px;
                font-weight: 500;
                padding: 3px 8px;
                border: 1px solid #cbd5e1;
                border-radius: 0 !important;
            }
            .gc-notes-text {
                font-size: 12.5px;
                color: #64748b;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
            }
            .gc-empty-dash {
                color: #cbd5e1;
            }
            .gc-row-actions {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
            }
            .gc-row-actions .gc-action-btn.edit {
                height: 32px;
                min-height: 32px;
                padding: 0 12px;
                font-size: 12.5px;
                box-sizing: border-box;
            }
            .gc-row-actions .gc-action-btn.delete {
                height: 32px;
                min-height: 32px;
                width: 32px;
                min-width: 32px;
                padding: 0;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                border-color: #cbd5e1;
                color: #ef4444;
                background: #ffffff;
                box-sizing: border-box;
            }
            .gc-row-actions .gc-action-btn.delete:hover {
                background: #fef2f2;
                border-color: #ef4444;
                color: #dc2626;
            }
            .gc-search-box {
                display: inline-flex;
                align-items: center;
                gap: 8px;
                background: #ffffff;
                border: 1px solid #cbd5e1;
                padding: 0 10px;
                height: 32px;
                box-sizing: border-box;
            }
            .gc-search-box i {
                color: #94a3b8;
                font-size: 12px;
            }
            .gc-search-box input {
                border: none;
                outline: none;
                font-size: 12.5px;
                color: #1e293b;
                width: 170px;
                background: transparent;
            }
            .gc-search-box input::placeholder {
                color: #94a3b8;
            }
            .gc-footer {
                padding: 16px 24px;
                background: #f8fafc !important;
                border-top: 1px solid #edf2f7 !important;
                display: flex;
                justify-content: flex-end;
            }
            @media (max-width: 768px) {
                .gc-toolbar { flex-direction: column; align-items: stretch; }
                .gc-tab-bar { align-items: stretch; border-bottom: 0; }
                .gc-tab-btn { flex: 1 1 100%; border-radius: 0; }
                .gc-doc-row { grid-template-columns: auto 34px minmax(0, 1fr); }
                .gc-selected-summary { grid-template-columns: 34px minmax(0, 1fr); }
                .gc-status, .gc-row-download, .gc-row-generate { grid-column: 1 / -1; justify-self: flex-start; }
            }
        `}</style>
        <Container
            {...(embedded ? { className: `gc-embedded${bodyOnly ? " gc-body-only" : ""}` } : {
                show: Boolean(showHide),
                size: "xl",
                centered: true,
                onHide: () => handleModalShowHide(""),
                dialogClassName: "rt-tools-modal gc-modal",
                backdrop: "static",
                keyboard: false
            })}
        >
            <Modal.Body className="p-0">
                <div className="gc-shell">
                    {!bodyOnly && (
                        <div className="gc-modal-header-wrapper">
                            <div className="modal-header">
                                <div className="rt-header-shell">
                                    <div className="rt-header-top">
                                        <div className="rt-header-main">
                                            <i className="rt-header-icon fa fa-file-text-o" aria-hidden="true" />
                                            <div className="rt-header-copy">
                                                <h2 className="rt-modal-title">
                                                    <span className="rt-modal-title-text">
                                                        <span>Generate Documents</span>
                                                        <span className="rt-modal-title-badge">Contract Generator</span>
                                                    </span>
                                                </h2>
                                                <div className="rt-modal-meta-row">
                                                    {uploadType && (
                                                        <span className="rt-meta-chip">
                                                            <i className="fa fa-briefcase" style={{ color: "#2563eb" }} />
                                                            <span>{uploadType}</span>
                                                        </span>
                                                    )}
                                                    {candidateName && (
                                                        <span className="rt-meta-chip">
                                                            <i className="fa fa-user" style={{ color: "#9333ea" }} />
                                                            <span>{candidateName}</span>
                                                        </span>
                                                    )}
                                                    {candidateId && (
                                                        <span className="rt-meta-chip">
                                                            <i className="fa fa-id-badge" style={{ color: "#6366f1" }} />
                                                            <span>ID: {candidateId}</span>
                                                        </span>
                                                    )}
                                                    {currentCiid && (
                                                        <span className="rt-meta-chip">
                                                            <i className="fa fa-hashtag" style={{ color: "#d97706" }} />
                                                            <span>CIID {currentCiid}</span>
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <button
                                            type="button"
                                            className="rt-action-btn"
                                            onClick={() => handleModalShowHide("")}
                                            title="Close"
                                        >
                                            <i className="fa fa-times" aria-hidden="true" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="gc-body">
                        {!bodyOnly && <div className="gc-tab-bar" role="tablist" aria-label="Generate contract actions">
                            <button
                                type="button"
                                role="tab"
                                aria-selected={selectedKey === "selectDocument"}
                                className={`gc-tab-btn ${selectedKey === "selectDocument" ? "active" : ""}`}
                                onClick={() => handleSelectedKey("selectDocument")}
                            >
                                <i className="fa fa-folder-open-o" />
                                <span>Select Document</span>
                                <span className="gc-tab-badge">{repositoryDocs.length}</span>
                            </button>
                            <button
                                type="button"
                                role="tab"
                                aria-selected={selectedKey === "generateDocument"}
                                className={`gc-tab-btn ${selectedKey === "generateDocument" ? "active" : ""}`}
                                onClick={() => handleSelectedKey("generateDocument")}
                            >
                                <i className="fa fa-magic" />
                                <span>Generate Document</span>
                                <span className="gc-tab-badge">{selectedDoc?.id || "—"}</span>
                            </button>
                            <button
                                type="button"
                                role="tab"
                                aria-selected={selectedKey === "manageMappings"}
                                className={`gc-tab-btn ${selectedKey === "manageMappings" ? "active" : ""}`}
                                onClick={() => handleSelectedKey("manageMappings")}
                            >
                                <i className="fa fa-list" />
                                <span>Manage Mappings</span>
                                <span className="gc-tab-badge">{dataTypeMappings.length}</span>
                            </button>
                            <button
                                type="button"
                                role="tab"
                                aria-selected={selectedKey === "addMapping"}
                                className={`gc-tab-btn ${selectedKey === "addMapping" ? "active" : ""}`}
                                onClick={() => handleSelectedKey("addMapping")}
                            >
                                <i className="fa fa-pencil-square-o" />
                                <span>{editingProfile ? "Edit Mapping" : "New Mapping"}</span>
                            </button>
                        </div>}

                        {!bodyOnly && canGenerateDocuments && selectedKey === "selectDocument" && (
                            <div className="gc-panel" role="tabpanel">
                                <div className="gc-toolbar">
                                    <div>
                                        <div className="gc-section-label">
                                            <i className="fa fa-folder-open-o" /> Select Document
                                        </div>
                                        <p className="gc-note">Select one DOCX template before generating the document.</p>
                                    </div>
                                    <div className="gc-actions">
                                        <button className="gc-action-btn" onClick={handleResetSelection} disabled={!selectedDocReady}>
                                            <i className="fa fa-refresh" /> Reset
                                        </button>
                                        <button className="gc-action-btn primary" onClick={() => handleDocRefresh(wfTask)} disabled={repositoryLoading}>
                                            <i className={`fa ${repositoryLoading ? "fa-spinner fa-spin" : "fa-repeat"}`} /> {repositoryLoading ? "Loading" : "Refresh"}
                                        </button>
                                    </div>
                                </div>
                                <div className="gc-doc-list">
                                    {showRepositoryLoading && (
                                        <div className="gc-state gc-state-loading">
                                            <div className="gc-empty-icon"><i className="fa fa-spinner fa-spin" /></div>
                                            <h5>Loading DDRMS documents</h5>
                                            <p>Fetching available DOCX templates for this workflow.</p>
                                        </div>
                                    )}
                                    {showRepositoryEmpty && (
                                        <div className="gc-state gc-state-empty">
                                            <div className="gc-empty-icon"><i className="fa fa-inbox" /></div>
                                            <h5>No DOCX templates found</h5>
                                            <p>Refresh the repository or upload a DOCX template before generating a document.</p>
                                        </div>
                                    )}
                                    {!showRepositoryLoading && repositoryDocs.map((item) => (
                                        <div
                                            key={`contract-template-${item.id}`}
                                            role="button"
                                            tabIndex={0}
                                            className={`gc-doc-row ${selectedDocId === item.id ? "selected" : ""}`}
                                            onClick={() => handleSelection(item)}
                                            onKeyDown={(event) => {
                                                if (event.key === "Enter" || event.key === " ") {
                                                    event.preventDefault();
                                                    handleSelection(item);
                                                }
                                            }}
                                        >
                                            <span className="gc-doc-checkbox">
                                                <input
                                                    type="checkbox"
                                                    checked={selectedDocId === item.id}
                                                    readOnly
                                                />
                                                <span className="gc-checkbox-custom" />
                                            </span>
                                            <span className="gc-doc-icon">
                                                <i className="fa fa-file-word-o" />
                                            </span>
                                            <span className="gc-doc-main">
                                                <span className="gc-doc-title">{item.name}</span>
                                                <span className="gc-doc-meta">
                                                    <span><i className="fa fa-hashtag" /> ID: {item.id}</span>
                                                    <span><i className="fa fa-file-o" /> .{item.fileExtension}</span>
                                                </span>
                                            </span>
                                            <button
                                                type="button"
                                                className="gc-row-download"
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    handleDownloadFile(item);
                                                }}
                                            >
                                                <i className="fa fa-download" /> Download
                                            </button>
                                            <button
                                                type="button"
                                                className="gc-row-generate"
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    handleGenerateFromSelection(item);
                                                }}
                                            >
                                                <i className="fa fa-magic" /> Generate
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {canGenerateDocuments && (bodyOnly || selectedKey === "generateDocument") && (
                            <div className="gc-panel" role="tabpanel">
                                {!selectedDocReady && (
                                    <div className="gc-no-selection">
                                        <div className="gc-no-selection-icon"><i className="fa fa-lock" /></div>
                                        <h5>No document selected</h5>
                                        <p>Select a DOCX template in the first tab before generating the document.</p>
                                        <button className="gc-action-btn primary" onClick={() => handleSelectedKey("selectDocument")}>
                                            <i className="fa fa-arrow-left" /> Select Document
                                        </button>
                                    </div>
                                )}
                                {selectedDocReady && (
                                    <>
                                        <div className="gc-selected-summary">
                                            <div className="gc-doc-icon">
                                                <i className="fa fa-file-word-o" />
                                            </div>
                                            <div className="gc-doc-main">
                                                <span className="gc-doc-title">{selectedDoc?.name}</span>
                                                <span className="gc-doc-meta">
                                                    <span><i className="fa fa-hashtag" /> ID: {selectedDoc?.id}</span>
                                                    <span><i className="fa fa-check-circle" /> Ready to generate</span>
                                                </span>
                                            </div>
                                            {!bodyOnly && <div style={{ display: "flex", gap: "8px" }}>
                                                <button className="gc-action-btn" onClick={() => handleSelectedKey("manageMappings")}>
                                                    <i className="fa fa-list" /> Manage Mappings
                                                </button>
                                                <button className="gc-action-btn" onClick={() => handleSelectedKey("addMapping")}>
                                                    <i className="fa fa-plus" /> New Mapping
                                                </button>
                                                <button className="gc-action-btn" onClick={() => handleSelectedKey("selectDocument")}>
                                                    <i className="fa fa-exchange" /> Change
                                                </button>
                                            </div>}
                                        </div>
                                        <div className="gc-mapping-wrap">
                                            <DataMapping
                                                workflowTask={wfTask}
                                                app={app}
                                                uploadType={uploadType}
                                                selectedObj={selectedDoc}
                                                applicantObj={applicantObj}
                                                viewType={viewType}
                                                handleCloseMapping={handleCloseMapping}
                                                goBack={() => handleSelectedKey("selectDocument")}
                                                defaultMappingId={defaultMappingId}
                                                autoSave={autoSave}
                                                deferSave={deferSave}
                                                initialGeneratedData={initialGeneratedData}
                                                onStageGenerated={onStageGenerated}
                                                bodyOnly={bodyOnly} />
                                        </div>
                                    </>
                                )}
                            </div>
                        )}

                        {!bodyOnly && canGenerateDocuments && selectedKey === "manageMappings" && (
                            <div className="gc-panel" role="tabpanel">
                                <div className="gc-toolbar">
                                    <div>
                                        <div className="gc-section-label">
                                            <i className="fa fa-list" /> Manage Mappings
                                        </div>
                                    </div>
                                    <div className="gc-actions">
                                        <div className="gc-search-box">
                                            <i className="fa fa-search" />
                                            <input
                                                type="text"
                                                placeholder="Search profiles..."
                                                value={profileSearchText}
                                                onChange={(e) => setProfileSearchText(e.target.value)}
                                            />
                                        </div>
                                        <button
                                            className="gc-action-btn"
                                            onClick={() => handleSelectedKey("selectDocument")}
                                        >
                                            <i className="fa fa-arrow-left" /> Back
                                        </button>
                                        <button
                                            className="gc-action-btn primary"
                                            onClick={() => {
                                                setEditingProfile(null);
                                                handleSelectedKey("addMapping");
                                            }}
                                        >
                                            <i className="fa fa-plus" /> Add New
                                        </button>
                                    </div>
                                </div>
                                <div className="gc-table-container">
                                    {dataTypeMappings.length === 0 ? (
                                        <div className="gc-empty gc-empty-profile" style={{ margin: "24px" }}>
                                            <div className="gc-empty-icon"><i className="fa fa-sliders" /></div>
                                            <h5>No mapping profiles found</h5>
                                            <p>Create a new datatype mapping profile to get started.</p>
                                        </div>
                                    ) : dataTypeMappings.filter(p => {
                                        if (!profileSearchText.trim()) return true;
                                        const q = profileSearchText.toLowerCase();
                                        return (p.name && p.name.toLowerCase().includes(q)) ||
                                               (p.id && p.id.toString().includes(q)) ||
                                               (p.notes && p.notes.toLowerCase().includes(q));
                                    }).length === 0 ? (
                                        <div className="gc-empty gc-empty-profile" style={{ margin: "24px" }}>
                                            <div className="gc-empty-icon"><i className="fa fa-search" /></div>
                                            <h5>No matching profiles</h5>
                                            <p>No profiles match "{profileSearchText}".</p>
                                        </div>
                                    ) : (
                                        <table className="gc-table">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: "8%", textAlign: "center" }}>ID</th>
                                                    <th style={{ width: "32%" }}>Profile Name</th>
                                                    <th style={{ width: "18%" }}>Configured Fields</th>
                                                    <th style={{ width: "27%" }}>Notes</th>
                                                    <th style={{ width: "15%", textAlign: "center" }}>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {dataTypeMappings.filter(p => {
                                                    if (!profileSearchText.trim()) return true;
                                                    const q = profileSearchText.toLowerCase();
                                                    return (p.name && p.name.toLowerCase().includes(q)) ||
                                                           (p.id && p.id.toString().includes(q)) ||
                                                           (p.notes && p.notes.toLowerCase().includes(q));
                                                }).map((item) => {
                                                    let fieldCount = 0;
                                                    try {
                                                        const parsed = JSON.parse(item.mappingJson);
                                                        fieldCount = Array.isArray(parsed) ? parsed.length : 0;
                                                    } catch (e) {
                                                        console.error("Error parsing mappingJson", e);
                                                    }
                                                    return (
                                                        <tr key={`profile-row-${item.id}`} className="gc-table-row">
                                                            <td style={{ textAlign: "center" }}>
                                                                <span className="gc-id-badge">#{item.id}</span>
                                                            </td>
                                                            <td>
                                                                <span className="gc-profile-name">{item.name}</span>
                                                            </td>
                                                            <td>
                                                                <span className="gc-fields-badge">
                                                                    <i className="fa fa-sliders" /> {fieldCount} {fieldCount === 1 ? "field" : "fields"}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <span className="gc-notes-text" title={item.notes || ""}>
                                                                    {item.notes || <span className="gc-empty-dash">—</span>}
                                                                </span>
                                                            </td>
                                                            <td style={{ textAlign: "center" }}>
                                                                <div className="gc-row-actions">
                                                                    <button
                                                                        type="button"
                                                                        className="gc-action-btn edit"
                                                                        onClick={() => {
                                                                            setEditingProfile(item);
                                                                            handleSelectedKey("addMapping");
                                                                        }}
                                                                        title="Edit profile"
                                                                    >
                                                                        <i className="fa fa-pencil" /> Edit
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className="gc-action-btn delete"
                                                                        onClick={() => handleDeleteProfile(item)}
                                                                        title="Delete profile"
                                                                    >
                                                                        <i className="fa fa-trash-o" />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                            </div>
                        )}

                        {!bodyOnly && canGenerateDocuments && selectedKey === "addMapping" && (
                            <div className="gc-panel" role="tabpanel">
                                <div className="gc-toolbar">
                                    <div>
                                        <div className="gc-section-label">
                                            <i className="fa fa-pencil-square-o" /> {editingProfile ? "Edit Mapping" : "New Mapping"}
                                        </div>
                                        <p className="gc-note">{editingProfile ? "Modify mapping configuration" : "Configure new mapping"}</p>
                                    </div>
                                    <div className="gc-actions">
                                        <button
                                            className="gc-action-btn"
                                            onClick={() => {
                                                setEditingProfile(null);
                                                handleSelectedKey("manageMappings");
                                            }}
                                        >
                                            <i className="fa fa-arrow-left" /> Back
                                        </button>
                                    </div>
                                </div>
                                <div className="gc-mapping-wrap" style={{ padding: "20px" }}>
                                    <AddDataTypeMapping
                                        app={app}
                                        applicantObj={applicantObj}
                                        editingProfile={editingProfile}
                                        clearEditingProfile={() => setEditingProfile(null)}
                                        handleAddNewMapping={() => {
                                            handleSelectedKey("manageMappings");
                                        }}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </Modal.Body>
            {!bodyOnly && <Modal.Footer className="gc-footer">
                <button
                    type="button"
                    className="wf-modal-footer-close-btn"
                    onClick={() => handleModalShowHide("")}
                >
                    <i className="fa fa-times" aria-hidden="true" /> Close
                </button>
            </Modal.Footer>}
        </Container>
    </>

}

export default GenerateContract;
